import React, { useState } from 'react';
import { FaPlusCircle } from "react-icons/fa";
import {
    Button,
    Form,
    Input,
    Modal,
    InputNumber,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function AddFormModal() {

    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();

    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/products/createCourse', data)
                .then(() => {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: 'Create successfully',
                        duration: 1,
                        onClose: () => form.resetFields()
                    });
                    queryClient.invalidateQueries(['/api/products/findCourses'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Create failed!',
                    });
                })
        },
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate(values))
    };

    const onCancelCreate = () => {
        form.resetFields();
        setOpen(false);
    }
    return (
        <div>
            {contextHolder}
            <Button
                type='primary'
                icon={<FaPlusCircle />}
                onClick={() => setOpen(true)}
            >Add</Button>
            <Modal
                open={open}
                title="Add Course"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        Ok
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name='addCourse'
                >
                    <Form.Item
                        name="name"
                        label="Course Name"
                        rules={[
                            {
                                required: true,
                                message: 'Please input data!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Price"
                        name="price"
                        rules={[
                            {
                                required: true,
                                message: 'Please input data!',
                            },
                        ]}
                    >
                        <InputNumber min={0} style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item name="description" label="Description">
                        <Input.TextArea rows={2} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>

    )
}
